import styled, { css } from 'styled-components';

import { Text } from 'shared/components/Text/Text';

export const HeaderStyled = styled.div<{ $showLogo: boolean; $headerAlwaysCentered: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
  align-items: ${({ $showLogo }) => ($showLogo ? 'left' : 'center')};
  ${({ $headerAlwaysCentered }) =>
    $headerAlwaysCentered
      ? css`
          h1 {
            text-align: center;
          }
        `
      : ''}
  svg {
    margin: 0 auto 12px;
    height: 48px;
    width: 48px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    align-items: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    svg {
      margin: 0 auto 20px;
      height: 60px;
      width: 60px;
    }
  }
`;

export const HeaderText = styled(Text)`
  font-family: Avenir;
  font-weight: 300;

  b {
    font-family: Avenir;
    font-size: 34px;
    font-style: normal;
    font-weight: 800;
    line-height: 44px;
  }
`;
